import SettingsSection from "./SettingsSection";

export default SettingsSection;